import React from 'react'
import { useSelector } from 'react-redux'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import Spoiler from '../../../../../../../../../components/Spoiler'
import Field from '../../../../../../../../../components/Form/Field'
// import FieldLabelWrapper from '../../../../../../../../../features/components/Form/FieldLabelWrapper'

import { PRODUCT_CUSTOM_TEXT } from '../../../../../fields'
import { selectedControllerDataSelector } from '../../../../../../../../../modules/selectors/app'

import useStyles from './styles'

const AssetCol = ({ formik, productPath }) => {
  const selectedController = useSelector(selectedControllerDataSelector)
  const customProductLabel = selectedController.product_custom_text_label
  const classes = useStyles()

  const customTextPath = `${productPath}[${PRODUCT_CUSTOM_TEXT}]`
  const customText = getIn(formik.values, customTextPath)

  return (
    <Spoiler
      initialOpen={!!customText}
      showArrow={false}
      title={`${customText ? '' : 'Add'} ${customProductLabel}${customText ? ':' : ''}`}
      className={classes.customTextSpoiler}
      spoilerTitleClassName={classes.spoilerTitle}
      spoilerOpenedTitleClassName={classes.spoilerOpenedTitle}
    >
      {/*<FieldLabelWrapper*/}
      {/*  label={`${customProductLabel}: `}*/}
      {/*  labelFor={customTextPath}*/}
      {/*  labelClassName={classes.fieldLabel}*/}
      {/*  horizontalView={true}*/}
      {/*>*/}
      <Field
        inputClassName={classes.customTextField}
        formik={formik}
        name={customTextPath}
        id={customTextPath}
        placeholder={''}
        setOnChange={true}
      />
      {/*</FieldLabelWrapper>*/}
    </Spoiler>
  )
}

AssetCol.propTypes = {
  formik: PropTypes.object.isRequired,
  productPath: PropTypes.string.isRequired
}
export default AssetCol
